import { HiOutlineEnvelope } from 'react-icons/hi2';

import ConfirmationModal from 'modules/v2/common/AtomicDesign/organisms/ConfirmationModal';

import strings from './strings';

interface PlacedOrder {
  orderId: string | null;
  quantity: number | null;
  approvalRequired: boolean;
}

interface OrderConfirmationModalProps {
  placedOrder: PlacedOrder | null;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  onConfirmation: () => void;
}

const ApprovalBody = ({ orderId, quantity }: { orderId: string | null; quantity: number | null }) => {
  const [beforeOrderId, afterOrderId = ''] = strings.approval.body.split('{orderId}');
  return (
    <>
      {beforeOrderId}
      <strong className="text-neutral-800">#{orderId}</strong>
      {afterOrderId.replace('{quantity}', String(quantity ?? ''))}
    </>
  );
};

/**
 * The confirmation after "Place order". An order that waits for the member's
 * e-mail approval (`approval.required`) asks them to check their inbox;
 * every other order keeps the "order is confirmed" copy.
 */
const OrderConfirmationModal = ({
  placedOrder,
  showModal,
  setShowModal,
  onConfirmation,
}: OrderConfirmationModalProps) => {
  if (placedOrder?.approvalRequired) {
    return (
      <ConfirmationModal
        icon={
          <div className="w-[52px] h-[52px] rounded-full bg-amber-100 flex items-center justify-center">
            <HiOutlineEnvelope size={26} className="text-amber-800" />
          </div>
        }
        badge={
          <span className="inline-block px-2.5 py-1 rounded-full bg-amber-100 text-amber-800 text-xs font-bold tracking-wide">
            {strings.approval.badge}
          </span>
        }
        title={strings.approval.title}
        description={
          <ApprovalBody orderId={placedOrder.orderId} quantity={placedOrder.quantity} />
        }
        footnote={strings.approval.footnote}
        showModal={showModal}
        setShowModal={setShowModal}
        onConfirmation={onConfirmation}
        confirmationText={strings.approval.action}
      />
    );
  }

  return (
    <ConfirmationModal
      title={strings.confirmed.title}
      description={strings.confirmed.description}
      showModal={showModal}
      setShowModal={setShowModal}
      onConfirmation={onConfirmation}
      confirmationText={strings.confirmed.action}
    />
  );
};

export default OrderConfirmationModal;
